export default __webpack_public_path__ + "static/media/404.d1560915.png";